import axios from '@/api/axios';
import type {
  AdminPaginatedEnvelope,
  AfriexQueryParams,
  BusinessAdminInviteRequest,
  BusinessOnboarding,
  BusinessOnboardingEditRequest,
} from '@/types';

export const inviteService = {
  async createOnboardingInvite(
    payload: BusinessAdminInviteRequest,
  ): Promise<void> {
    await axios.post(`/v2/admin/business/onboarding`, payload);
  },

  async getOnboardingInvites(
    params: AfriexQueryParams,
  ): Promise<{list: BusinessOnboarding[]; total: number}> {
    const response = await axios.get<
      AdminPaginatedEnvelope<BusinessOnboarding[]>
    >(`/v2/admin/business/onboarding`, {
      params,
    });
    return {
      // Server normalized this list to the {data,total,page} envelope; the
      // service keeps exposing {list,total} to its callers.
      list: response.data.data,
      total: response.data.total,
    };
  },

  // Approves a pending invite, or re-sends an approved one's link.
  async sendOnboardingInviteLink(id: string): Promise<void> {
    await axios.post(`/v2/admin/business/onboarding/${id}/approve`);
  },

  async denyOnboardingInvite(id: string): Promise<void> {
    await axios.post(`/v2/admin/business/onboarding/${id}/reject`);
  },

  async updateOnboardingInvite(
    id: string,
    payload: BusinessOnboardingEditRequest,
  ): Promise<void> {
    await axios.patch(`/v2/admin/business/onboarding/${id}`, payload);
  },
};
